import ayiaNapaNissiBeachImage from "../assets/cyprus/ayia-napa-nissi-beach.webp";
import kakopetriaImage from "../assets/cyprus/kakopetria.webp";
import larnacaFinikoudesImage from "../assets/cyprus/larnaca-finikoudes.webp";
import lefkaraVillageImage from "../assets/cyprus/lefkara-village.webp";
import limassolHotelsHeroImage from "../assets/cyprus/limassol-hotels-hero.webp";
import limassolMarinaImage from "../assets/cyprus/limassol-marina.webp";
import nicosiaLedraStreetImage from "../assets/cyprus/nicosia-ledra-street.webp";
import omodosVillageImage from "../assets/cyprus/omodos-village.webp";
import paphosCastleImage from "../assets/cyprus/paphos-castle.webp";
import protarasFigTreeBayImage from "../assets/cyprus/protaras-fig-tree-bay.webp";
import troodosHeroImage from "../assets/cyprus/troodos-hero.webp";

const destinationHeroImages = [
  ["ayia napa", ayiaNapaNissiBeachImage],
  ["protaras", protarasFigTreeBayImage],
  ["troodos", troodosHeroImage],
  ["kakopetria", kakopetriaImage],
  ["lefkara", lefkaraVillageImage],
  ["omodos", omodosVillageImage],
  ["nicosia", nicosiaLedraStreetImage],
  ["larnaca", larnacaFinikoudesImage],
  ["paphos", paphosCastleImage],
  ["limassol-hotels", limassolHotelsHeroImage],
  ["limassol", limassolMarinaImage],
];

export function getDestinationHeroImage(value = "") {
  const normalized = value.toLowerCase();
  const match = destinationHeroImages.find(([destination]) =>
    normalized.includes(destination)
  );

  return match ? match[1] : limassolMarinaImage;
}
